import * as React from 'react';
import { useEffect, useRef } from 'react';
import useResizeObserver from '@react-hook/resize-observer';

import { useStores } from 'hooks';

import { sendResizeMessage } from 'modules/resize-message';

import {
  getBrandingConfig,
  getRequestedLobsConfig,
  getSearchConfig,
  Panel,
  useSearchWidgetContext,
} from 'features/search-widget';

function SearchWidget(): JSX.Element {
  const {
    app: { program, routeQueries },
  } = useStores();

  const { setBranding, setLobs, setSearch } = useSearchWidgetContext();

  const widget = useRef<HTMLElement>();

  useEffect(() => {
    setBranding(getBrandingConfig({ programId: program.id }));
    setLobs(getRequestedLobsConfig({ programId: program.id, lobIds: routeQueries['lobs'] }));
    setSearch(getSearchConfig({ programId: program.id }));
  }, [program, routeQueries]); // eslint-disable-line react-hooks/exhaustive-deps

  useResizeObserver(widget, function handleResize(entry): void {
    sendResizeMessage({
      type: 'eg-widget/resize',
      meta: {
        instance: routeQueries.instance,
      },
      payload: {
        frame: {
          style: {
            width: '100%',
            height: `${entry.contentRect.height}px`,
          },
        },
      },
    });
  });

  return (
    <article ref={widget} className="widget">
      <Panel />
    </article>
  );
}

export { SearchWidget };
